module.exports = __webpack_public_path__ + "static/media/ic_facebook.95d3141d.svg";